const PrivacyPolicy = () => {
  return (
    <div className="min-h-screen bg-gray-50 py-16 px-6">
      <div className="max-w-3xl mx-auto bg-white shadow-md rounded-xl p-8">
        <h1 className="text-3xl font-bold text-purple-800 mb-6">Privacy Policy</h1>

        <p className="mb-4 text-gray-700">
          At <strong>EmpowerHer</strong>, we are committed to protecting your privacy. This Privacy Policy outlines how we collect, use, and protect your personal information when you interact with our platform.
        </p>

        <h2 className="text-xl font-semibold text-purple-700 mt-8 mb-2">1. Information We Collect</h2>
        <p className="text-gray-700 mb-4">
          We may collect personal information that you voluntarily provide through forms, including:
        </p>
        <ul className="list-disc pl-6 text-gray-700 space-y-1">
          <li>Your name</li>
          <li>Email address</li>
          <li>Your message or inquiry</li>
        </ul>

        <h2 className="text-xl font-semibold text-purple-700 mt-8 mb-2">2. How We Use Your Information</h2>
        <p className="text-gray-700 mb-4">
          The information we collect is used to:
        </p>
        <ul className="list-disc pl-6 text-gray-700 space-y-1">
          <li>Respond to your inquiries or support requests</li>
          <li>Improve our website and user experience</li>
          <li>Send updates or information you’ve requested</li>
        </ul>

        <h2 className="text-xl font-semibold text-purple-700 mt-8 mb-2">3. Data Sharing & Security</h2>
        <p className="text-gray-700 mb-4">
          We do not sell, rent, or trade your personal information. Your data is stored securely and only accessible by authorized personnel.
        </p>

        <h2 className="text-xl font-semibold text-purple-700 mt-8 mb-2">4. Your Rights</h2>
        <p className="text-gray-700 mb-4">
          You have the right to access, correct, or delete your personal data. Please contact us at <a href="mailto:empowerherforfuture@gmail.com" className="text-purple-600 hover:underline">empowerherforfuture@gmail.com</a> for any requests.
        </p>

        <h2 className="text-xl font-semibold text-purple-700 mt-8 mb-2">5. Changes to This Policy</h2>
        <p className="text-gray-700 mb-4">
          We may update this Privacy Policy occasionally. All updates will be posted on this page with the revised date.
        </p>

        <p className="text-sm text-gray-500 mt-10">
          Last updated: June 2025
        </p>
      </div>
    </div>
  );
};

export default PrivacyPolicy;
